import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Paper, StackColumn } from '@dhl-ui/components'
import { NativeModal } from '@dhl/native-modal'

import { type Servicepoint } from '@dhl/receiver-servicepoint'
import { NewServicepointInAreaContent } from '~/interaction/new-servicepoint/NewServicepointInAreaContent.js'

type Props = {
  open: boolean
  onClose: () => void
  isLoading: boolean
  servicepoint?: Servicepoint
  typeKey: 'locker' | 'servicepoint'
}

export const NewServicePointInAreaModal: FC<Props> = ({ open, onClose, isLoading, servicepoint, typeKey }) => {
  const { t } = useTranslation()

  return (
    <NativeModal open={open} onClose={onClose}>
      <NativeModal.Header title={t(`portal.servicepoints.${typeKey}.newTitle`)} onClose={onClose} />
      <NativeModal.Content noPaddingSides>
        <Paper hasNoOverflowHidden background="dark">
          <StackColumn gap={3}>
            <NewServicepointInAreaContent isLoading={isLoading} servicepoint={servicepoint} typeKey={typeKey} />
          </StackColumn>
        </Paper>
      </NativeModal.Content>
    </NativeModal>
  )
}
